/* Locale switcher dialog controller. Moved out of snippets/locale-switcher-dropdown.liquid
   (2026-09-11): it was ~9.5 KB of uncacheable inline JS on every page and only ever ran
   on DOMContentLoaded, so a deferred cached asset is behaviour-identical. */
document.addEventListener('DOMContentLoaded', function() {
  // Elements
  const trigger = document.querySelector('[data-locale-trigger]');
  const dropdown = document.querySelector('[data-locale-dropdown]');
  const overlay = document.querySelector('[data-locale-overlay]');
  const searchInput = document.querySelector('[data-region-search]');
  const regionList = document.querySelector('[data-region-list]');
  const noResults = document.querySelector('[data-no-results]');

  // Form inputs
  const form = document.querySelector('#locale-form');
  if (!form) return;

  const countryInput = form.querySelector('[data-country-input]');
  const localeInput = form.querySelector('[data-locale-input]');

  // State
  let selectedCountry = countryInput ? countryInput.value : '';
  let selectedLocale = localeInput ? localeInput.value : '';
  let regionItems = [];
  let langBtns = [];
  let regionsHydrated = false;
  /* True only when the visitor clicked a LANGUAGE button. A region click picks a
     country and derives a default locale, which is not a language choice: writing
     sacrasoul_locale_set from it would mute language routing for a year because
     someone changed their delivery country. */
  let languageChosen = false;
  let hiddenOutside = [];
  // Sho, 2026-09-12: "One click on the language/region you want should change
  // it, without an extra click." The Save button is gone, so a row click both
  // selects and submits. The page is about to navigate; this flag makes sure a
  // second click (or an Enter on an already-firing row) cannot post twice.
  let submitted = false;

  function hideOutsideDialog() {
    hiddenOutside = [];
    let node = dropdown;
    while (node && node.parentElement) {
      Array.from(node.parentElement.children).forEach(sibling => {
        if (sibling === node) return;
        hiddenOutside.push({ element: sibling, previous: sibling.getAttribute('aria-hidden') });
        sibling.setAttribute('aria-hidden', 'true');
      });
      node = node.parentElement;
      if (node === document.body) break;
    }
  }

  function restoreOutsideDialog() {
    hiddenOutside.forEach(entry => {
      if (entry.previous === null) entry.element.removeAttribute('aria-hidden');
      else entry.element.setAttribute('aria-hidden', entry.previous);
    });
    hiddenOutside = [];
  }

  function hydrateRegions() {
    if (regionsHydrated) return true;
    if (!regionList) return false;
    // Looked up at hydration time, not at DOMContentLoaded: the raw source is
    // fetched on intent (assets/ss-header-payloads.js) and lands in the mount later.
    const regionSource = document.querySelector('[data-ss-deferred-header-payloads] [data-region-source]')
      || document.querySelector('[data-region-source]');
    if (!regionSource) {
      // The breakout-guard fallback rendered the rows live instead of as an
      // inert payload. Adopt them into the list and bind, so the switcher
      // works identically. This page just loses the deferral.
      const liveGroups = document.querySelectorAll('.locale-region-group');
      if (!liveGroups.length) return false;
      liveGroups.forEach(g => { if (g.parentElement !== regionList) regionList.appendChild(g); });
      regionsHydrated = true;
      bindRegionControls();
      return true;
    }
    try {
      const staging = document.createElement('template');
      staging.innerHTML = regionSource.textContent.trim();
      if (!staging.content.querySelector('.locale-region-group')) return false; // keep source, retry next open
      regionList.appendChild(staging.content);
      regionSource.remove();
      regionsHydrated = true;
      bindRegionControls();
      return true;
    } catch (err) {
      /* parse failed: keep the source for a retry on the next open */
      return false;
    }
  }

  // ========================================
  // TOGGLE DROPDOWN
  // ========================================
  function openDropdown() {
    /* Never lock the page behind an empty dialog if deferred markup cannot be
       parsed. The trigger stays usable so the shopper can retry. */
    if (!hydrateRegions()) {
      /* The region list is fetched on intent (assets/ss-header-payloads.js); a
         click that beats the fetch opens once the rows are in place. */
      var hp = window.SacrasoulHeaderPayloads;
      if (hp && !hp.done) (hp.ready || hp.load()).then(function (ok) { if (ok) openDropdown(); });
      return;
    }
    if (dropdown) dropdown.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    hideOutsideDialog();
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(() => searchInput && searchInput.focus());
  }

  function closeDropdown(restoreFocus) {
    if (dropdown) dropdown.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    restoreOutsideDialog();
    document.body.style.overflow = '';
    if (searchInput) {
      searchInput.value = '';
      filterRegions('');
    }
    if (restoreFocus && trigger) requestAnimationFrame(() => trigger.focus());
  }

  if (trigger) trigger.addEventListener('click', openDropdown);
  if (overlay) overlay.addEventListener('click', () => closeDropdown(true));

  // Close on click outside dropdown
  document.addEventListener('click', (e) => {
    if (!dropdown || !dropdown.classList.contains('is-open')) return;

    // If click is on trigger, let the trigger handler deal with it
    if (trigger && trigger.contains(e.target)) return;

    // If click is inside dropdown, don't close
    if (dropdown.contains(e.target)) return;

    // Click is outside - close dropdown
    closeDropdown(false);
  });

  document.addEventListener('keydown', (e) => {
    if (!dropdown || !dropdown.classList.contains('is-open')) return;
    if (e.key === 'Escape') {
      closeDropdown(true);
      return;
    }
    if (e.key === 'Tab') {
      const focusable = Array.from(dropdown.querySelectorAll('button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'));
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  // ========================================
  // SEARCH
  // ========================================
  if (searchInput && regionList) {
    searchInput.addEventListener('input', (e) => {
      filterRegions(e.target.value.toLowerCase().trim());
    });
  }

  function filterRegions(query) {
    if (!regionList) return;
    const groups = regionList.querySelectorAll('.locale-region-group');
    let totalVisible = 0;

    groups.forEach(group => {
      const items = group.querySelectorAll('.locale-region-item');
      let groupVisible = 0;

      items.forEach(item => {
        const name = (item.dataset.countryName || '').toLowerCase();
        const matches = name.includes(query);
        item.style.display = matches ? '' : 'none';
        if (matches) groupVisible++;
      });

      group.style.display = groupVisible === 0 ? 'none' : '';
      totalVisible += groupVisible;
    });

    if (noResults) {
      noResults.style.display = totalVisible === 0 ? 'block' : 'none';
    }
  }

  // ========================================
  // REGION SELECTION
  // ========================================
  function bindRegionControls() {
    regionItems = Array.from(regionList.querySelectorAll('.locale-region-item'));
    langBtns = Array.from(regionList.querySelectorAll('.locale-lang-btn'));

    regionItems.forEach(item => {
      item.addEventListener('click', (e) => {
        if (e.target.classList.contains('locale-lang-btn')) return;
        languageChosen = false;
        selectRegion(item);
        applySelection(item);
      });
      item.addEventListener('keydown', (e) => {
        if (e.target !== item || (e.key !== 'Enter' && e.key !== ' ')) return;
        e.preventDefault();
        languageChosen = false;
        selectRegion(item);
        applySelection(item);
      });
    });

    langBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();

        const item = btn.closest('.locale-region-item');
        const langOptions = item.querySelector('.locale-lang-options');

        if (langOptions) {
          langOptions.querySelectorAll('.locale-lang-btn').forEach(b => b.classList.remove('active'));
        }
        btn.classList.add('active');

        selectedLocale = btn.dataset.langCode;
        languageChosen = true;
        selectRegion(item);
        // selectRegion re-reads the active button, so the language the visitor
        // just pressed is the one that ships.
        applySelection(item);
      });
    });
  }

  function selectRegion(item) {
    regionItems.forEach(i => {
      i.classList.remove('selected');
      i.setAttribute('aria-selected', 'false');
    });
    item.classList.add('selected');
    item.setAttribute('aria-selected', 'true');

    selectedCountry = item.dataset.countryCode;

    // Get language
    const langOptions = item.querySelector('.locale-lang-options');
    if (langOptions) {
      const activeBtn = langOptions.querySelector('.locale-lang-btn.active');
      if (activeBtn) {
        selectedLocale = activeBtn.dataset.langCode;
      } else {
        const firstBtn = langOptions.querySelector('.locale-lang-btn');
        if (firstBtn) {
          firstBtn.classList.add('active');
          selectedLocale = firstBtn.dataset.langCode;
        }
      }
    } else {
      // The row names the one language we publish for it (snippets/locale-country-langs).
      const single = item.querySelector('[data-default-lang]');
      selectedLocale = (single && single.dataset.defaultLang) || 'en';
    }
  }

  // ========================================
  // APPLY
  // ========================================
  // One click = one navigation. The row takes a pressed/busy state first so the
  // click is acknowledged during the reload, which on a cold market switch can
  // take a second or two.
  function applySelection(item) {
    if (submitted) return;
    if (!form) return;
    submitted = true;

    if (item) {
      item.classList.add('is-applying');
      item.setAttribute('aria-busy', 'true');
    }
    if (regionList) regionList.setAttribute('aria-busy', 'true');

    if (countryInput) countryInput.value = selectedCountry;
    if (localeInput) localeInput.value = selectedLocale;
    // A LANGUAGE choice, and only that, is remembered: snippets/locale-auto-detect
    // reads this cookie and never routes that visitor by browser language again,
    // even if the browser language changes. A country change must not write it.
    if (languageChosen && selectedLocale) {
      document.cookie =
        'sacrasoul_locale_set=' + encodeURIComponent(String(selectedLocale).toLowerCase()) +
        '; path=/; max-age=' + (365 * 24 * 60 * 60);
    }
    // Any region picked here is deliberate: assets/ss-market-route.js never
    // moves this visitor to another store after it. form.submit() fires no
    // submit event, so the mark is written here rather than by a listener.
    document.cookie = 'ss_mkt_chosen=1; path=/; max-age=' + (365 * 24 * 60 * 60) + '; samesite=lax';
    if (window.SSMarketMarkPick) window.SSMarketMarkPick(form, languageChosen ? selectedLocale : '');
    form.submit();
  }

});
